import type { CSSProperties, HTMLAttributes } from "react";
import { cx } from "./cx";

/** 表单与卡片里的小网格（设计系统 Grid）：间距与顶部对齐统一，columns 为 2 时两等分，传字符串时按它定列宽。 */
export function Grid({ columns, className, style, ...rest }: HTMLAttributes<HTMLDivElement> & { columns?: 2 | string }) {
  const s: CSSProperties | undefined = typeof columns === "string" ? { gridTemplateColumns: columns, ...style } : style;
  return <div className={cx("ax-grid", columns === 2 && "ax-grid-2", className)} style={s} {...rest} />;
}
